export enum Permission {
  ManageUsers = 'manage_users.legacy_permission',
  ViewRoles = 'role_management.view',
  ModifyRoles = 'role_management.modify',
}
